import React from "react";
import { useTable } from "react-table";
import { Paginator } from "../../_commons/Paginator";
import ExclamatoryIcon from "../../_icons/ExclamatoryIcon";

const ReactTable = ({
	colsArray = [],
	loading = false,
	error = false,
	columns,
	data,
	classes = "",
	rowspanned = [],
	thStyles = { cols: [], styles: {} },
	limit = 10,
	offset = 0,
	count = 0,
	goToPage = () => {},
	setPageSize = () => {},
	customTableHead = false,
	renderTableHead = () => {},
	fetchData = () => {}
}) => {
	const { getTableProps, getTableBodyProps, rows, prepareRow } = useTable({
		columns,
		data
	});

	const rowSpanHeaders = columns
		.filter((col) => col.enableRowSpan)
		.map((col) => ({ id: col.accessor, topCellValue: -1e9, topCellIndex: -1 }));

	rows.forEach((row, i) => {
		prepareRow(row);

		row.allCells.forEach((cell, j) => {
			const rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);
			if (rowSpanHeader) {
				if (rowSpanHeader.topCellValue === -1e9 || !deepCheck(rowSpanHeader.topCellValue, cell.value)) {
					rowSpanHeader.topCellValue = cell.value;
					rowSpanHeader.topCellIndex = i;
					cell.rowSpan = 1;
				} else {
					const topCell = rows[rowSpanHeader.topCellIndex].allCells[j];
					topCell.rowSpan = (topCell.rowSpan || 1) + 1;
					cell.isRowSpanned = true;
				}
			}
		});
	});

	return (
		<div className={`react-table-container  `}>
			{!loading && error && <ErrorDiv fetchData={fetchData} />}
			<table className={`react-table ${classes}`} {...getTableProps()}>
				<thead>
					{customTableHead ? (
						renderTableHead()
					) : (
						<tr>
							{colsArray.map((column) => (
								<th
									style={{
										...(!thStyles.cols.includes(column?.id) ? thStyles.styles : {})
									}}
									className={`th-head th-${column?.id}`}
									key={column?.id}
								>
									{column.render()}
								</th>
							))}
						</tr>
					)}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row) => (
						<tr {...row.getRowProps()}>
							{row.cells.map((cell) =>
								cell?.isRowSpanned ? null : (
									<td
										className={`td-cell td-${cell.column.id}`}
										{...cell.getCellProps()}
										rowSpan={cell.rowSpan ?? 1}
										style={{
											height: "100%",
											verticalAlign: "top",
											...(rowspanned.length == 1 &&
												row.cells.reduce((acc, curr) => {
													if (curr?.isRowSpanned) acc += 1;
													return acc;
												}, 1) > 1 && { borderTop: "1px dashed #EAEAEA" }),
											...(rowspanned.length == 1 &&
												row.cells.reduce((acc, curr) => {
													if (curr?.isRowSpanned) acc += 1;
													return acc;
												}, 1) == 1 && { borderTop: "1px solid #EAEAEA" })
										}}
									>
										<>{cell.render("Cell")}</>
									</td>
								)
							)}
						</tr>
					))}
				</tbody>
			</table>
			{!loading && (
				<Paginator
					limit={limit}
					offset={offset}
					count={count}
					showPageSize={true}
					goToPage={goToPage}
					setPageSize={setPageSize}
				/>
			)}
		</div>
	);
};

export default ReactTable;

const ErrorDiv = ({ fetchData = () => {} }) => {
	return (
		<div className="error-div">
			<div className="exclamatory-div">
				<ExclamatoryIcon fill={"#EAEAEA"} width={98} height={98} />
			</div>
			<div className="error-info">
				<div className="text">
					<div className="head">Could not load this chart!</div>
					<div className="para">We are facing some issue while fetching this data for you</div>
				</div>
				<div className="refresh-button" onClick={() => fetchData()}>
					<img className="load-again-img" src="/assets/periscope/load-again.svg" />
					<span className="try-again">Try Again</span>
				</div>
			</div>
		</div>
	);
};

const deepCheck = (a, b) => {
	if (a === b) {
		return true;
	}
	if (typeof a !== typeof b || Array.isArray(a) !== Array.isArray(b)) {
		return false;
	}
	if (Array.isArray(a)) {
		if (a.length !== b.length) {
			return false;
		}
		return a.every((_, index) => deepCheck(a[index], b[index]));
	} else if (typeof a === "object") {
		const aKeys = Object.keys(a);
		const bKeys = Object.keys(b);

		if (aKeys.length !== bKeys.length) {
			return false;
		}
		return aKeys.every((key) => deepCheck(a[key], b[key]));
	}
	return false;
};
